import { getTestAttributes, slug } from '@chillibean/component-library';

import { getFieldTitle } from '../../../__util__/field';
import withInputLabel from '../hoc/withInputLabel';

export function TextareaField(props) {
  const {
    value,
    disabled,
    handleChange,
    handleBlur,
    handleClick,
    fieldID,
    fieldRequired,
    fieldIdentifier = 'textarea',
    fieldName,
    showError,
    errorMessage,
  } = props;

  const handleOnChange = (event) => handleChange && handleChange(event, 'textarea');
  const handleOnBlur = (event) => handleBlur && handleBlur(event, 'textarea');
  const handleOnClick = (event) => handleClick && handleClick(event);

  return (
    <div className="form__field">
      <textarea
        id={fieldID}
        style={!fieldName ? { paddingTop: '15px' } : null}
        className={`form__control form__control--textarea ${showError ? 'form__control--validation-error' : ''}`}
        placeholder=" "
        onClick={(event) => handleOnClick(event)}
        onBlur={(event) => handleOnBlur(event)}
        onChange={(event) => handleOnChange(event)}
        disabled={disabled}
        value={value}
        {...getTestAttributes(`${slug(fieldIdentifier)}-form-field`)}
      />
      <label htmlFor={fieldID}>{getFieldTitle(fieldRequired, fieldName)}</label>
      {showError && (
        <div className="form__validation-error" data-test-id={`${slug(fieldIdentifier)}-form-field-error-message`}>
          {errorMessage}
        </div>
      )}{' '}
    </div>
  );
}

export default withInputLabel(TextareaField);
